import type { CharterSeatConfigurationOverrideParams } from '~/services/CharterService';

export const charterSeatConfigurationOverrideQueryKeys = {
  all: ['flights-charter', 'seat-configuration-overrides'] as const,
  lists: () => [...charterSeatConfigurationOverrideQueryKeys.all, 'list'] as const,
  list: (params: CharterSeatConfigurationOverrideParams) =>
    [...charterSeatConfigurationOverrideQueryKeys.lists(), params] as const,
  details: () => [...charterSeatConfigurationOverrideQueryKeys.all, 'detail'] as const,
  detail: (flightInstanceId: string) =>
    [...charterSeatConfigurationOverrideQueryKeys.details(), flightInstanceId] as const,
};
